import { useEffect } from "react";

/**
 * Mette un blocco JSON-LD nel <head> finche' il componente resta montato,
 * e lo toglie quando si cambia pagina. Non disegna niente.
 */
export default function DatiStrutturati({ id, dati }) {
  const json = dati ? JSON.stringify(dati) : null;

  useEffect(() => {
    if (!json) return undefined;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.ld = id;
    script.text = json;
    document.head.appendChild(script);

    return () => script.remove();
  }, [id, json]);

  return null;
}
